import { Component, ViewChild } from '@angular/core';
import * as Notiflix from 'notiflix';
import { ClickEventArgs } from '@syncfusion/ej2-navigations'
import { GridComponent } from '@syncfusion/ej2-angular-grids';
import { ActivatedRoute, Router } from '@angular/router';
import { StorageService } from 'src/app/core/shared/services/storage.service';
import { Profile } from 'src/app/core/shared/models/profile';
import { Company } from 'src/app/core/shared/models/company.model';
import { HomeService } from '../home/services/home.service';
import { Equipement } from 'src/app/core/shared/models/equipement';
import { ValidationWorkorderService } from './services/validation-workorder.service';
import { AuthService } from 'src/app/core/auth/services/auth.service';
import { StatusProfileBlockAndReturnScan } from 'src/app/core/shared/models/statusProfileBlockAndReturnScan.model';
import { CommunService } from 'src/app/services/commun.service';
declare var bootstrap: any;

@Component({
  selector: 'app-validation-workorder',
  templateUrl: './validation-workorder.component.html',
  styleUrls: ['./validation-workorder.component.scss']
})
export class ValidationWorkorderComponent {

  @ViewChild('workOrdersGrid') workOrdersGrid: GridComponent;
  @ViewChild('cardWorkOrdersGrid') cardWorkOrdersGrid: any;   
  userProfil = "";

  pageName = 'validationWorkorder'
  workOrdersData: Object[];
  selectOptions: Object;
  editSettings: Object;
  currentUserName ="";
  userProfilTitle = "";
  BIXI_userAuthObject: any = null
  currentProfile: Profile = null
  currentProfiles: Profile[] = []
  currentUserCompany: Company | undefined;
  selectedWorEquipment= "";
  equipement: Equipement = null
  equipementNo: string = ''
  isUserBlocked: boolean = true;  
  
  constructor(private router: Router,
    private storageService: StorageService,
    private activatedRoute: ActivatedRoute,
    private homeService: HomeService,
    private validationWorkorderService: ValidationWorkorderService,
    private AuthService: AuthService,
    private readonly communService: CommunService,
  ) { }


  ngOnInit() {
    this.communService.initNotiflix();

    // check if user has data in browser storage, else redirect himn to login page
    if(!this.storageService.getItem("bixi-user-auth") || !this.storageService.getItem("bixi-currentCompany") || !this.storageService.getItem("bixi-currentProfile")){
      this.router.navigateByUrl('/auth/login')
    }else{
      this.BIXI_userAuthObject = JSON.parse(this.storageService.getItem("bixi-user-auth"));
      this.currentUserCompany = JSON.parse(this.storageService.getItem("bixi-currentCompany"));
      this.currentProfile = JSON.parse(this.storageService.getItem("bixi-currentProfile"));
      this.currentProfiles = JSON.parse(this.storageService.getItem("bixi-currentProfiles"));
      this.equipementNo =  this.storageService.getItem('currentSerialNumber')
      if(this.storageService.getItem('Bixi_BlockAndReturnScan')){
        let BlockAndReturnScan: StatusProfileBlockAndReturnScan  = JSON.parse(this.storageService.getItem('Bixi_BlockAndReturnScan'));
        this.isUserBlocked = BlockAndReturnScan ? JSON.parse(this.storageService.getItem('Bixi_BlockAndReturnScan'))?.isBlockedAction : true
      }
     
    }
    this.getEquipement();
    localStorage.setItem("bixiApp_isTemplateReadOnly", "0");
    this.editSettings = { allowAdding: true };
    // Bootstrap tooltip initialization
    var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
    tooltipTriggerList.map(function (tooltipTriggerEl) {
    return new bootstrap.Tooltip(tooltipTriggerEl)
    })     
  }

  changeProfile(profil){
    if(profil){
  
      const profileFound = this.currentProfiles.find(currentProfile => currentProfile.profil == profil)
  
      localStorage.setItem("bixi-currentProfile", JSON.stringify(profileFound));
      this.reloadCurrentRoute()

    }else{
      this.AuthService.logout()
    }
  }

  reloadCurrentRoute() {
    let currentUrl = this.router.url;
    currentUrl = currentUrl.replace('%20', ' ');
    location.reload()
  }

  logout(){
    Notiflix.Confirm.show(
      'Confirmation',
      "Êtes-vous sûr de vouloir vous déconnecter?",
      'Confirmer',
      'Annuler',
      () => {
        this.router.navigateByUrl('/')
      },
      () => {},
      );
  }

  validateWorkOrder(){
    var selectedRecords = this.workOrdersGrid.getSelectedRecords();
    for(let k=0; k<selectedRecords.length; k++){
    const index = this.workOrdersData.indexOf(selectedRecords[k]);
      if (index > -1) {
        this.workOrdersData[index]["State"] = "Validé"; 
      }
    }
    this.communService.showLoading();
    setTimeout(() => {
      Notiflix.Loading.remove();
      this.workOrdersGrid.refresh();
       this.communService.notifySuccess("Bons de tavail validés avec succès!");
    }, 2000);
  }

  getRandomNumber(min: number,max: number) {
    min = Math.ceil(min);max = Math.floor(max);
    return Math.floor(Math.random() * (max - min) + min);
  }

  getEquipement(){
    this.activatedRoute.params.subscribe(params => {
      this.equipementNo = params['equipementNo'];
      // checjk if equipementNo is in url
      if(this.equipementNo){
        this.equipementNo = this.equipementNo.replace('%20', ' ')
      this.communService.showLoading();
      this.homeService.getEquipement(this.BIXI_userAuthObject.tenantId, this.currentUserCompany.id, this.equipementNo).subscribe({
        next: (equipement) => {
          this.equipement = equipement.value[0]
          this.validationWorkorderService.getWorkorders(this.BIXI_userAuthObject.tenantId, this.currentUserCompany.id, "status eq 'A valider'").subscribe({
            next: (workOrdersData) => {
                this.workOrdersData = workOrdersData.value
            },
            error: (error) => {
            }
          })
          Notiflix.Loading.remove();
        },
        error: (error) => {
          Notiflix.Loading.remove();
          this.communService.notifyFailure(error);
        }
      })  
      }
    })
  }

  refreshEquipementEvent(){
    this.getEquipement()
  }
  
  toolbarClick(args: ClickEventArgs): void {
    switch (args.item.text) {
        case 'Valider':
            this.confirmWorkorder();
            break;
        case 'Afficher/masquer':
            this.workOrdersGrid.openColumnChooser(window.innerWidth-373, 40);
            break;
        default:
          alert(args.item.text)
    }
  }

  columnsShowHide(){
    this.workOrdersGrid.openColumnChooser(window.innerWidth-373, 0);
  }
  confirmWorkorder(){
      if(this.workOrdersGrid.getSelectedRecords()?.length <= 0){
        this.communService.notifyFailure("Aucun bon de tavail sélectionné!");
      }
      else{
     Notiflix.Confirm.show(
        'Confirmation',
        "Voulez-vous vraiment valider ces bons de travail?",
        'Confirmer',
        'Annuler',
        () => {
          this.validateWorkOrder()
        },
        () => {}
        );
      }
  }
}
